import { useCallback } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { ButtonLink, FavoriteButton } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import routes from "@/lib/routes";
import Link from "next/link";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ChannelPickupListRow(_ref) {
  let {
    item
  } = _ref;
  const handleClick = useCallback(e => {
    if (!item.isAllowedRating) {
      e.preventDefault();
    }
  }, [item]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.container, styles.pickup, {
      [styles.notAllowed]: !item.isAllowedRating
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.artwork,
        children: /*#__PURE__*/_jsx(CardArtwork, {
          item: item,
          className: styles.artworkInner,
          href: routes.channelDetail(item.id),
          linkAttr: {
            onClick: handleClick
          }
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.info,
        children: [/*#__PURE__*/_jsx("h4", {
          className: styles.title,
          children: /*#__PURE__*/_jsx(Link, {
            href: routes.channelDetail(item.id),
            onClick: handleClick,
            children: item.name
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.genre,
          children: /*#__PURE__*/_jsx("span", {
            children: item.genres.map(genre => genre.name).join("/")
          })
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: item.description
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.buttons,
          children: [/*#__PURE__*/_jsx(ButtonLink, {
            fillColor: true,
            medium: true,
            href: routes.channelDetail(item.id),
            disabled: !item.isAllowedRating,
            children: "\u8A73\u7D30\u3092\u898B\u308B"
          }), /*#__PURE__*/_jsx(FavoriteButton, {
            transparent: true,
            borderGray: true,
            metaId: item.id,
            text: "\u304A\u6C17\u306B\u5165\u308A"
          })]
        })]
      })]
    })
  });
}